import {LauncherOverridesReader} from '../launcher-overrides-reader/launcher-overrides-reader';
import {ILoggerService} from '../../services/logger/logger.service.interface';
import {isInsideAutomation} from '../../../utils/automation-helpers';

export class B2CFrameworkLoader {
  constructor(private _launcherOverridesReader: LauncherOverridesReader, private _languageIso2: string, private _logger: ILoggerService) {
    let overrides = this._launcherOverridesReader.getOverrides();
    this._cmsSource = overrides && overrides.orbit && overrides.orbit.cmsSource;
    if(this._cmsSource && !this._cmsSource.endsWith('/')) {
      this._cmsSource += '/'
    }
  }

  private readonly _cmsSource: string;



  private _buildFilePath(fileName: string): string {
    return `https://storage.googleapis.com/cw-prod/${fileName}`;
  }

  //Important Note - this function also responsible   load the b2c scripts/CSS in the AOD app
  async loadB2CFramework(): Promise<void> {

    try {
      if(isInsideAutomation()) {
        return;
      }


      if(!this._cmsSource) {
        return;
      }

      this._loadStyleTag('b2c_main_css', this._buildFilePath('main.css'));
      this._loadScriptTag('b2c_jquery-lib.js', this._buildFilePath('jquery-lib.js'));
      this._loadScriptTag('b2c_main_js', this._buildFilePath('lib.js'));
      this._loadScriptTag('b2c_lib_js', this._buildFilePath('main.js'));
    } catch (err) {
      this._logger.error('Failed to load B2C framework', err);
    }
  }

  private _loadScriptTag(id: string, url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      var scriptTag = document.createElement('script');
      scriptTag.id = id;
      scriptTag.src = url;
      scriptTag.onload = () => {
        resolve();
      };
      scriptTag.onerror = (err) => {
        this._logger.error(`Failed to load B2C script from ${url}`, err);
        reject(err);
      };
      document.head.appendChild(scriptTag);
    });


  };

  private _loadStyleTag(id: string, url: string): void {
    var styleTag = document.createElement('link');
    styleTag.id = id;
    styleTag['href'] = url;
    styleTag['rel'] = 'stylesheet';
    styleTag['type'] = 'text/css';
    styleTag.onerror = (err) => {
      this._logger.error(`Failed to load B2C stylesheet from ${url}`, err);
    };

    document.head.appendChild(styleTag);
  }
}
